export default function calculateIndex(data, currentPage, perPage) {
  return (currentPage - 1) * perPage + data.index + 1;
}
